import clsx from 'clsx';
import type { InputHTMLAttributes } from 'react';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> & {
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  hint?: string;
  onValueChange: (v: number) => void;
  displayValue?: (v: number) => string;
};

export function Slider({ label, value, min, max, step = 1, hint, onValueChange, displayValue, className, ...rest }: Props) {
  return (
    <label
      className={clsx('flex flex-col gap-1 text-sm', className)}
      {...(hint !== undefined ? { title: hint } : {})}
    >
      <span className="flex justify-between text-neutral-400">
        <span className="flex items-center gap-1">
          {label}
          {hint !== undefined && (
            <span aria-hidden="true" className="text-neutral-500 text-[10px] cursor-help">?</span>
          )}
        </span>
        <span className="font-mono text-neutral-200">{displayValue ? displayValue(value) : value}</span>
      </span>
      <input
        type="range" min={min} max={max} step={step} value={value}
        onChange={(e) => onValueChange(Number(e.target.value))}
        className="h-1 w-full appearance-none bg-neutral-800 rounded accent-white"
        {...rest}
      />
    </label>
  );
}
